import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NavService} from '../../../_services/_nav.service';
import {Modalidad} from '../../../_models/modalidad';
import {ListaService} from '../../../_services/lista.service';
import {ModalidadAutorizacionService} from '../../../_services/modalidad-autorizacion.service';
import {ModalidadTasa} from '../../../_models/modalidad-tasa';
import {ModalidadTasaService} from '../../../_services/modalidad-tasa.service';

@Component({
  selector: 'app-modalidades-tasas',
  templateUrl: 'modalidades-tasas.component.html'
})

export class ModalidadesTasasComponent implements OnInit {

  @Input() modalidad: Modalidad;
  @Output() dismiss: EventEmitter<string> = new EventEmitter();
  modalidadTasa: ModalidadTasa;
  // Lista de modalidades tasas
  lisModalidadesTasas: ModalidadTasa [] = [];
  carInformacionInicial = true;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  loadingTabla = false;

  constructor(private modAutServicio: ModalidadAutorizacionService,
              private modTasaServicio: ModalidadTasaService,
              private conServicio: ConfirmationService,
              private lisServicio: ListaService,
              private nav: NavService,
              private confirmationService: ConfirmationService,
              private fb: FormBuilder) {

  }

  ngOnInit(): void {
    // Definiendo columnas datatable
    this.columnas = [
      {field: 'tasa', header: this.nav.buscarMensaje('MODALIDADES.LBL_TASA'), sort: false},
      {field: 'fecha', header: this.nav.buscarMensaje('MODALIDADES.LBL_FECHA'), sort: false},
      {field: 'habilitado', header: this.nav.buscarMensaje('MODALIDADES.LBL_HABILITADO'), sort: false},
    ];
    // Inicializando formulario
    this.inicializarFormulario();
    // Inicializando las listas
    this.inicializarListas();
  }

  inicializarListas() {
    this.lisModalidadesTasas = [];
    this.carInformacionInicial = true;
      this.modTasaServicio.listadoModalidadesTasasIdModalidad(this.modalidad.idModalidad).subscribe(
        modalidadesTasa => {
        this.lisModalidadesTasas = modalidadesTasa;
        this.lisModalidadesTasas.reverse();
        this.carInformacionInicial = false;
      }
    );
  }

  inicializarFormulario() {
    this.formulario = this.fb.group({
      tasa: [null, [Validators.required]],
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.lisModalidadesTasas.find(x => x.tasa === Number(this.f.tasa.value))) {
      this.nav.setMesage( 0, {
        severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.nav.buscarMensaje( 'MODALIDADES.LBL_YAEXISTEUNATASACONESTEVALOR' )
      });
      return;
    }
    if (this.formulario.valid) {
      this.crearModalidadTasa();
    }
  }


  crearModalidadTasa() {
      this.guardando = true;
      this.modalidadTasa = {} as ModalidadTasa;
      this.modalidadTasa.indicadorHabilitado = true;
      this.modalidadTasa.tasa = this.formulario.value.tasa;
      this.modalidadTasa.idModalidad = this.modalidad.idModalidad;
      this.modalidadTasa.idModalidadTasa = null;
      this.modTasaServicio.crear(this.modalidadTasa).subscribe(
        res => {
          this.nav.setMesage(1);
          this.guardando = false;
          this.submitted = false;
          this.formulario.reset();
          this.inicializarListas();
        },
        error => {
          this.nav.setMesage(3);
          this.formulario.reset();
          this.submitted = false;
          this.guardando = false;
        });
  }

  get f() {
    return this.formulario.controls;
  }

  /* habilitar o inhabilitar el registro seleccionado teniendo en cuenta que solo puede haber un registro
  habilitado*/
  habilitarInhabilitar(row: ModalidadTasa) {
    this.guardando = true;
    this.loadingTabla = true;
    this.lisModalidadesTasas.map(x => {
      if (x.idModalidadTasa != row.idModalidadTasa) {
        x.indicadorHabilitado = false;
      }
    })
    this.modTasaServicio.bulk(this.lisModalidadesTasas).subscribe(
      (res) => {
        this.nav.setMesage(1);
        this.guardando = false;
        this.loadingTabla = false;
        this.inicializarListas();
      },
      (error) => {
        this.nav.setMesage(3);
        this.guardando = false;
        this.loadingTabla = false;
      }
    );
  }
}
